import ComponentHelper from '../../../supers/ComponentHelper';
import Modal from 'react-modal';
import React from 'react';
import './install-app-modal.css';
import Spinner from '../../../components/spinner/Spinner';
import RESTService from '../../../services/RESTService';
import Dropdown from '../../../components/dropdown/Dropdown';
import CommonService from '../../../services/CommonService';
import RoutingService from '../../../services/RoutingService';
import _ from 'lodash';
const connect = new RESTService();
const CS = new CommonService();
const RS = new RoutingService();

class InstallAppModal extends ComponentHelper {
	constructor(props) {
		super(props);
		this.setInitialData(props);
	}

	setInitialData = props => {
		this.data = {
			title: 'Install an application',
			saving: false,
			errorMessage: null,
			applications: [],
			selectedApp: '',
			selectedVersion: '',
			appMap: {},
			warning: null,
			environment: props.environment
		};
	};

	// Clear component state when modal is re-open
	componentWillReceiveProps(nextProps) {
		if (!this.props.isOpen && nextProps.isOpen) {
			this.observe(() => {
				this.setInitialData(nextProps);
				RS.setCurrentEnvironment(nextProps.environment.name);
			});
			connect.getInstallableApps().then(res => {
				this.observe(() => {
					let apps = [];
					_.forEach(res.data, app => {
						if (app.published) {
							apps.push(app);
						}
					});
					this.data.applications = apps;
					this.data.appMap = CS.mapByParam('_id', apps);
				});
			});
		}
	}

	isValidInput() {
		return true;
	}

	clearError = () => {
		this.setData('errorMessage', null);
	};

	onInstall = () => {
		this.setData('saving', true);
		let selected = this.data.appMap[this.data.selectedApp];
		let apps = this.data.environment.installedApps;
		if (!apps) {
			apps = {};
		}
		if (apps && selected) {
			let toInstall = {
				_id: selected._id,
				name: selected.name,
				installDate: new Date(),
				version: selected.version
			};
			apps[selected.name] = toInstall;
			connect
				.installAppDef(toInstall)
				.then(() => {
					this.data.environment.installedApps = apps;
					connect
						.updateEnvironment(this.data.environment)
						.then(() => {
							this.props.onComplete();
						})
						.catch(err => {
							this.observe(() => {
								this.data.saving = false;
								this.data.errorMessage = err.response.data;
							});
						});
				})
				.catch(err => {
					this.observe(() => {
						console.error(err);
						this.data.saving = false;
						this.data.errorMessage = err.response.data;
					});
				});
		}
	};

	getApps = () => {
		let options = [];
		this.data.applications.forEach(app => {
			options.push({
				label: `${app.displayName} - v${app.version}`,
				value: app._id
			});
		});
		return options;
	};

	//TODO will need this in future
	// getAppVersions = () => {
	// 	let options = [];
	// 	let name = this.data.appMap[this.data.selectedApp].name;
	// 	this.data.applications.forEach(app => {
	// 		if (app.name === name) {
	// 			options.push({
	// 				label: app.version,
	// 				value: app.version
	// 			});
	// 		}
	// 	});
	// 	return options;
	// };

	onAppChange = evt => {
		let app = this.data.appMap[evt.value];
		if (app) {
			this.setData('selectedApp', app._id);
		}
		let installed = this.data.environment.installedApps;
		if (installed && installed[app.name]) {
			this.setData('warning', 'Another version of this app is already installed and will be overwritten.');
		} else {
			this.setData('warning', null);
		}
	};

	// onVersionChange = evt => {
	// 	this.setData('selectedVersion', evt.value);
	// };

	render() {
		let { isOpen } = this.props;
		let { title, saving, errorMessage, selectedApp, warning } = this.data;
		return (
			<Modal
				contentLabel="Modal"
				ariaHideApp={false}
				isOpen={isOpen}
				className="install-app-modal animated zoomIn"
				overlayClassName="dialog-modal-overlay vbox hcenter vcenter"
			>
				<div className="modal-header">{title}</div>
				{saving ? (
					<Spinner text="Installing..." height="267px" />
				) : errorMessage === null ? (
					<div className="modal-body">
						<Dropdown
							className="app-picker"
							label="Select an Application"
							value={selectedApp}
							placeholder="Select an app to install"
							handleChange={this.onAppChange}
							name="authType"
							options={this.getApps()}
						/>
						{/*{selectedApp.length > 0 && (*/}
						{/*<Dropdown*/}
						{/*className="app-picker"*/}
						{/*label="Select a version"*/}
						{/*value={selectedVersion}*/}
						{/*placeholder="Select the app version to install"*/}
						{/*handleChange={this.onVersionChange}*/}
						{/*name="authType"*/}
						{/*options={this.getAppVersions()}*/}
						{/*/>*/}
						{/*)}*/}
						{warning && (
							<div className="warning-msg hbox vcenter">
								<i className="mdi mdi-alert" /> {warning}
							</div>
						)}
					</div>
				) : (
					<div className="error-message-body vbox vcenter hcenter">{errorMessage}</div>
				)}
				<div className="btn-ctn">
					<button className="btn cancel-btn" onClick={this.props.onClose} disabled={saving}>
						Cancel
					</button>
					<button className="btn primary" onClick={errorMessage ? this.clearError : this.onInstall} disabled={!this.isValidInput() || saving}>
						{errorMessage ? 'Ok' : 'Install'}
					</button>
				</div>
			</Modal>
		);
	}
}
export default InstallAppModal;



// WEBPACK FOOTER //
// ./src/views/environments-panel/install-app-modal/InstallAppModal.js